import { useEffect, Suspense } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { initRudderStack, pageView, identifyUser } from "@/shared/lib/rudderstack-client";
import { trackEvent as trackGtmEvent } from "@/shared/lib/gtm";
import { useAuth } from "@/app/providers/AuthProvider";

function AnalyticsTracker() {
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const { data: session, isPending } = useAuth();

  // Initialize on mount
  useEffect(() => {
    initRudderStack();
  }, []);

  // Track pageviews
  useEffect(() => {
    if (pathname) {
      // 1. RudderStack Tracking
      pageView(pathname, undefined, { search: searchParams?.toString() });

      // 2. GTM / GA4 SPA Tracking
      // Push a custom page_view event so GTM's "History Change" or custom triggers can pick it up
      trackGtmEvent("page_view", {
        page_path: pathname,
        page_search: searchParams?.toString() || "",
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  }, [pathname, searchParams]);

  // Identify user when session loads
  useEffect(() => {
    if (!isPending && session?.user) {
      identifyUser(session.user.id, {
        email: session.user.email,
        name: session.user.name,
        createdAt: session.user.createdAt,
      });
    }
  }, [session, isPending]);

  return null;
}

export function AnalyticsProvider() {
  return (
    <Suspense fallback={null}>
      <AnalyticsTracker />
    </Suspense>
  );
}
